
class effect{
    FOCUS = `
    box-shadow: 0px 0px 0px 4px rgba(100, 210, 247, 0.1);
    `

    DROP_SHADOW_CARD = `
    box-shadow: 0px 4px 15px rgba(58, 61, 151, 0.1);
    `

    DROP_SHADOW_BUTTON = `
      background: #C4C4C4;
      box-shadow: 0px 3px 5px rgba(58, 61, 151, 0.15);
    `

    transition_200 = `
    transition:200ms;
    `

    transition_300 = `
    transition:300ms;
    `
}

export default new effect();